import { SvgIcon, SvgIconProps } from "@mui/material";

export const AppsIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 16 16" fill="none">
    <rect
      x="0.350946"
      y="0.350946"
      width="6.31703"
      height="6.31703"
      stroke="currentColor"
      fill="none"
      strokeWidth="0.701893"
    />
    <rect
      x="0.350946"
      y="8.77477"
      width="6.31703"
      height="6.31703"
      stroke="currentColor"
      fill="none"
      strokeWidth="0.701893"
    />
    <rect
      x="8.7738"
      y="0.350946"
      width="6.31703"
      height="6.31703"
      stroke="currentColor"
      fill="none"
      strokeWidth="0.701893"
    />
    <rect
      x="8.7738"
      y="8.77477"
      width="6.31703"
      height="6.31703"
      stroke="currentColor"
      fill="none"
      strokeWidth="0.701893"
    />
  </SvgIcon>
);
